import common from './common.json';
import errors from './errors.json';
import validation from './validation.json';
import domain from './domain.json';
import domainErrors from './domain-errors.json';

export const sharedResources = {
  'es-AR': {
    common,
    errors,
    validation,
    domain,
    'domain-errors': domainErrors,
  },
} as const;

export type SharedResources = typeof sharedResources;
